module.exports = "<!-- <app-slider-style1></app-slider-style1> -->\r\n<app-slider-style2></app-slider-style2>"


//////////////////
// WEBPACK FOOTER
// ./src/app/sliders/sliders.component.html
// module id = ./src/app/sliders/sliders.component.html
// module chunks = main